<template>
  <el-dialog
    :close-on-click-modal="true"
    class="guarantee-refund-dialog"
    :visible.sync="dialogVisible"
    width="70%"
    :show-close="true"
  >
    <div class="dialog-content" v-loading="loading">
      <div class="content-wrapper" v-html="tplContent"></div>
    </div>
  </el-dialog>
</template>

<script>
import { getContentDetailByType } from '@/api/comm'

export default {
  name: 'GuaranteeRefundDialog',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      tplContent: ''
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this.fetchContent()
    },
    async fetchContent() {
      this.loading = true
      try {
        const res = await getContentDetailByType({
          tplType: 'GUARANTEE_REFUND',
          tplChannel: '1'
        })
        if (res.code === 200 && res.data) {
          this.tplContent = res.data.tplContent || ''
        }
      } catch (error) {
        console.error('获取保函退款情形内容失败', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.guarantee-refund-dialog ::v-deep .el-dialog__header {
  border-bottom: none;
  padding: 0;
}

.guarantee-refund-dialog ::v-deep .el-dialog__body {
  padding: 0 24px 24px;
  overflow-y: auto;
}

.guarantee-refund-dialog ::v-deep .el-dialog {                                                  
    margin-top: 5vh !important;
}
</style>
